const isRTCProposal = proposal => proposal?.bank?.shortName === 'rtc';

export default isRTCProposal;
